// extracted by mini-css-extract-plugin
module.exports = {"paddingX":"styles_paddingX__5xwFv"};